import { modalComponentModule } from '../modal/modal';
import busyIndicatorDialogTemplate from './busy-indicator-dialog.tpl.html';
import './busy-indicator.less';

export const busyIndicatorComponentModule = angular
  .module('Q.components.busy-indicator', [modalComponentModule])

  .component('busyIndicator', {
    bindings: {
      size: '<',
    },
    controller: function BusyIndicatorCtrl($element) {
      this.$onInit = function () {
        let size = this.size || 6;
        for (let i = 0; i < size; i++) {
          $element.append('<span>');
        }
        this.$onChanges = (changes) => {
          if (changes.size) {
            $element.empty();
            this.$onInit();
          }
        };
      };
    },
    template: '',
  })

  .factory('busyIndicatorDialog', function ($modal, $timeout) {
    let dialog;
    let ctrl;
    return {
      /**
       *
       * @param {string} options.message - Main message
       * @param {string} options.title - Main title
       * @param {number?} options.size - Number of dots
       * @param {boolean?} options.closeable - If true, allow user to close the dialog
       */
      open(options) {
        if (ctrl) {
          angular.extend(ctrl, options);
          return;
        }

        dialog = $modal.openOnce('busyIndicatorDialog', {
          template: busyIndicatorDialogTemplate,
          controller: function () {
            ctrl = this;
            angular.extend(ctrl, options);
            ctrl.cancel = () => dialog.dismiss();
          },
          controllerAs: '$ctrl',
          backdrop: 'static',
          windowClass: 'busy-indicator-dialog no-intercom',
          size: 'md',
          keyboard: false,
        });

        dialog.result.finally(() => {
          dialog = ctrl = null;
        });
      },
      get showing() {
        return !!dialog;
      },
      close() {
        if (dialog) {
          const _dialog = dialog;
          dialog = ctrl = null;
          $timeout(() => {
            _dialog.dismiss();
          });
        }
      },
    };
  });
